/**
 * =============================================================================
 * LAS SALAS UNITY QUE SE VEN DENTRO DEL PORTAL
 * =============================================================================
 * Cinco salas de `educa360experiences.com` estan hechas con Unity y NO emiten
 * codigo de vinculacion. El portal las trataba como "juego VR con codigo": al
 * pulsar Generar sala, la sala se creaba y la URL aparecia, pero el panel de la
 * derecha se quedaba clavado en "Esperando a vincular el codigo del juego VR".
 * Un codigo que estas salas no dan nunca. Resultado practico: el terapeuta le
 * daba a lanzar y no salia nada.
 *
 * Aqui se nombran una a una. Es una lista escrita a mano a proposito, no un
 * patron.
 *
 * POR QUE LA LISTA ES DE ANFITRIONES EXACTOS Y NO DEL DOMINIO
 * ------------------------------------------------------------
 * En `educa360experiences.com` viven ademas otras 27 salas -mariposas, botones,
 * hojas, golf, alfareria...- que SI funcionan con codigo de vinculacion y cuya
 * telemetria depende de el. Un `endsWith(".educa360experiences.com")` se las
 * llevaria por delante a todas: dejarian de pedir el codigo y su sesion se
 * quedaria sin datos clinicos.
 *
 * Por eso se compara el `hostname` completo y con igualdad. Ademas de no tocar
 * a las otras 27, eso descarta solo los sufijos (`...experiences.com.otro.sitio`)
 * y los que solo lo llevan en la ruta o en el fragmento.
 *
 * SE PUEDEN EMBEBER: comprobado el 2026-09-10, las cinco responden con
 *
 *   content-security-policy: frame-ancestors 'self'
 *       https://educa360revi.web.app https://educa360revi.com
 *       https://www.educa360revi.com http://localhost:3006
 *
 * y sin `X-Frame-Options`. O sea que el iframe del portal esta contemplado por
 * el servidor de las salas, localhost incluido para poder probarlo. Si algun dia
 * una deja de listar el origen de REVI, esa sala saldra en blanco dentro del
 * portal: el aviso llegara por la consola del navegador, no por aqui.
 * =============================================================================
 */

export const SALAS_UNITY_EMBEBIDAS = [
  "quimica.educa360experiences.com",
  "orquesta.educa360experiences.com",
  "reciclaje.educa360experiences.com",
  "arquimedes.educa360experiences.com",
  "gruacarola.educa360experiences.com",
];

/**
 * Si la URL es una de las cinco salas Unity que el portal muestra embebidas.
 *
 * @param {string} url URL de la escena (`ModOneUrlsala`) o de la sala lanzada
 *                     (`hubsRoomUrl`). Ambas valen: el lanzamiento directo copia
 *                     la primera en la segunda sin transformarla.
 * @returns {boolean}
 */
export function esSalaUnityEmbebida(url) {
  if (!url || typeof url !== "string") return false;
  try {
    const anfitrion = new URL(url).hostname.toLowerCase();
    return SALAS_UNITY_EMBEBIDAS.includes(anfitrion);
  } catch {
    // Un id pelado de Hubs, una cadena vacia o cualquier cosa que no sea una
    // URL absoluta: no es ninguna de las cinco.
    return false;
  }
}
